export var AiAgentAppName;
(function (AiAgentAppName) {
    AiAgentAppName["AI_AGENT_APP_NAME_AI_ASSISTANT"] = "ai_assistant";
    AiAgentAppName["AI_AGENT_APP_NAME_DASHBOARD_ASSISTANT"] = "dashboard_assistant";
})(AiAgentAppName || (AiAgentAppName = {}));
